import { FC } from 'react';

import { useNotifications } from 'ui-kit/hooks/useNotifications';
import NotificationsDropdown from 'ui-kit/Notifications/NotificationsDropdown';

export const NotificationsSection: FC = () => {
  const { notifications, loading } = useNotifications();

  return (
    <div data-tour="notification-center">
      <h2 className="mb-4 font-heebo text-lg font-medium text-white">Notification Center</h2>
      <NotificationsDropdown
        notifications={notifications}
        loading={loading}
        className="!mt-0 max-h-[100%] bg-notification-gradient pb-[40px] shadow-none"
      />
    </div>
  );
};
